// import router from '@/router/index'
import axios, { AxiosInstance, AxiosRequestConfig, Method, ResponseType } from 'axios'
import { message } from 'ant-design-vue';
import useStore from '../store/index'
import Cookies from 'js-cookie';
/** http请求类，集成拦截器处理
 * opts = {
 *     baseURL: string  基础URL地址
 *     timeout: number  超时时长（毫秒）
 *     token: string    每次请求携带的Authorization值
 *     requestHandle function(config):config 请求处理函数，返回处理后的config
 *     responseHandle function(response):response 响应处理函数，返回处理后的response
 * }
 */
interface PendingType {
  url: string;
  method?: Method;
  data?: any;
  responseType?: ResponseType,
  queryParam?: any,
  headers?: Record<string, string>;
  hideError?: boolean;
}
class Http {
  http: AxiosInstance;
  constructor() {
    this.http = axios.create({
      baseURL: process.env.VUE_APP_API_URL,
      timeout: 600000,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      withCredentials: true
  });
    // const pending: any = {}
    // const CancelToken = axios.CancelToken
    // const removePending = (key: any, isRequest = false) => {
    //   if (pending[key] && isRequest) {
    //     pending[key]('请勿重复请求')
    //     message.error({content: '请勿重复请求，请稍等！！'})
    //   }
    //   delete pending[key]
    // }
    // const getRequestIdentify = (config: any, isRequest = false) => {
    //   let url = config.url
    //   if (isRequest) {
    //     url = config.baseURL + config.url.substring(1, config.url.length)
    //   }
    //   const arr = ['put', 'post']
    //   return arr.includes(config.method)
    //     ? encodeURIComponent(url + JSON.stringify(config.params))
    //     : encodeURIComponent(config.url + JSON.stringify(config.data))
    // }
    // 添加请求拦截器
    this.http.interceptors.request.use((config: AxiosRequestConfig) => {
      // 发送请求之前，拦截重复请求(即当前正在进行的相同请求)
      // const requestData = getRequestIdentify(config, true)
      // removePending(requestData, true)
      // config.cancelToken = new CancelToken((c) => {
      //   pending[requestData] = c
      // })
      const token = Cookies.get('token')
      if(token) {
        config.headers = {
          'Content-Type': 'application/json',
          'SESSION-ID': token,
          'authorization': 'Bearer ' + token
        }
      } else {
        config.headers = {
          'Content-Type': 'application/json',
        }
      }
      return config;
    }, function (error) {
      // 对请求错误做些什么
      return Promise.reject(error);
    });

    // 添加响应拦截器
    this.http.interceptors.response.use(response => {
      if(response.status === 200 && response.request.responseType === 'blob') {
        return response.data
      }
      if (response.status === 200 && (response.data.code === 2000 || response.data.code === 0)) {
        if(response.data.data) {
          return response.data.data;
        }
        return response.data;
      }

      // if(response.status === 200 && response.data.code === 2000) {
      //   useStore.commit('OUT_LOGIN')
      //   router.push({ path: "/login" });
      // }
      if (!(response.config as any)?.hideError) {
        if(typeof response.data.msg === 'string'){
          message.error({content: String(response.data.msg), type: 'error'})
        }else{
          message.error({
            content: JSON.stringify(response.data.msg, null, 2),
            type: 'error'
          });
        }
      }

      return Promise.reject(response.data)
    }, (error) => {
      const res = error.response
      const hideError = !!(error.config as any)?.hideError
      if(res.status === 403) {
        if(res.data.code == 4999 ) { // 鉴权失败重新登录
          if (!hideError) message.error({content: res.data.msg, type: 'error'})
          location.href = '/login'
          useStore.commit('OUT_LOGIN')
          return
        }
        return Promise.reject(res.data)
      }
      if(res.status === 401) { // 鉴权失败重新登录
        if (!hideError) message.error('登录已失效')
        location.href = '/login'
        useStore.commit('OUT_LOGIN')
        return
      }
      if(res.status === 500) {
        if (!hideError) {
          message.error('请求服务器异常')
          return
        }
        return Promise.reject(res)
      }
      if(res.status === 400) {
        if (!hideError) {
          const reader  = new FileReader();  //创建一个FileReader实例
          reader.readAsText(res.data, 'utf-8'); //读取文件,结果用字符串形式表示
          reader.onload = function() {//读取完成后,**获取reader.result**
            const  {msg}  = JSON.parse(reader.result as string);
            message.error({content: msg, type: 'error'})
          }
        }
      }
      // 对响应错误做点什么
      return Promise.reject(res);
    });
  }
 /**
   * 解析URL
   * @param url <string> '/aaa/:id'
   * @param routeParam = <object|map> {id: 1234} 将使用此对象的属性值替换url中的参数
   * @param queryParam = <object|map> {name: 'abc', attr: 'def'} url后面的查询参数
   * @returns {string}
   */

  parseUrl(url: string, params:any) {
    if (params) {
        const queryStrings = [];
        for (const i in params) {
            if (params[i] !== null && params[i] !== undefined && params[i] !== '') {
              queryStrings.push(`${i}=${params[i]}`);
            }
        }
        if(queryStrings.length !== 0) {
          url += '?' + queryStrings.join('&');
        }
    }
    return url;
  }
  /**
   * 请求方法
   * @param url <string> '/aaa/:id'
   * @param param <object|map> {
   *     queryParam = {name: 'abc', attr: 'def'} url后面的查询参数
   * }
   * 解析后的 url = '/aaa/1234?name=abc&attr=def'
   * @returns {Promise<*>}
   */
  get(types: PendingType) {
    if (types?.queryParam) {
      types.url = this.parseUrl(types.url, types?.queryParam);
    }
    return this.http.get(types.url,{responseType: types.responseType});
  }
  post(types: PendingType) {
    if (types?.queryParam) {
      types.url = this.parseUrl(types.url, types?.queryParam);
    }
    return this.http.post(types.url, types.data, {
      responseType: types.responseType,
      hideError: types.hideError,
    } as any);
  }
  put(types: PendingType) {
    if (types?.queryParam) {
      types.url = this.parseUrl(types.url, types?.queryParam);
    }
    return this.http.put(types.url, types.data, {responseType: types.responseType});
  }
  patch(types: PendingType) {
    if (types?.queryParam) {
      types.url = this.parseUrl(types.url, types?.queryParam);
    }
    return this.http.patch(types.url, types.data, {responseType: types.responseType});
  }
  delete(types: PendingType) {
    if (types?.queryParam) {
      types.url = this.parseUrl(types.url, types?.queryParam);
    }
    return this.http.delete(types.url, {responseType: types.responseType});
  }
}

export const api = new Http()
